/* IU Storefront Quality Product 1.3.7 — presentation only, no network requests or cart writes. */
(() => {
  'use strict';
  // Server-rendered stock messages remain useful without JavaScript. Keep the
  // visible message aligned with the theme's selected variant when it changes.
  if (!customElements.get('iu-product-availability')) {
    class ProductAvailability extends HTMLElement {
      connectedCallback() {
        if (this.onChange) return;
        this.onChange = event => {
          const view = this.closest('.productView');
          const target = event.target;
          if (!view || !(target instanceof Element)) return;
          const picker = target.closest('variant-selects, variant-radios');
          if (picker && view.contains(picker)) {
            this.showVariant(picker.currentVariant?.id);
          } else if (target.matches('[name="id"]') && target.form?.id === `product-form-${this.dataset.productId}`) {
            this.showVariant(target.value);
          }
        };
        document.addEventListener('change', this.onChange);
      }
      disconnectedCallback() {
        document.removeEventListener('change', this.onChange);
        this.onChange = null;
      }
      showVariant(id) {
        const panels = [...this.querySelectorAll('[data-iu-variant]')];
        const selected = panels.find(panel => panel.dataset.iuVariant === String(id));
        const visible = selected || panels.find(panel => panel.dataset.iuVariant === 'unavailable');
        panels.forEach(panel => { panel.hidden = panel !== visible; });
        this.dataset.currentVariant = visible?.dataset.iuVariant || '';
      }
    }
    customElements.define('iu-product-availability', ProductAvailability);
  }
  const gallery = document.querySelector('.productView-image-wrapper');
  if (gallery) {
    const stabilize = () => {
      const badges = [...gallery.querySelectorAll('.iu-curation-badges[data-iu-curation-current-product-badges]')];
      let stable = badges.find(badge => badge.parentElement === gallery);
      for (const badge of badges) {
        if (badge.parentElement === gallery) continue;
        // Leave an inert marker so the existing badge renderer does not re-inject
        // a duplicate into the first slide on the next recommendation refresh.
        const marker = document.createElement('span');
        marker.hidden = true;
        marker.setAttribute('data-iu-curation-current-product-badges', 'true');
        badge.replaceWith(marker);
        if (stable) badge.remove();
        else { gallery.classList.add('iu-stable-badge-gallery'); gallery.append(badge); stable = badge; }
      }
    };
    stabilize();
    new MutationObserver(stabilize).observe(gallery, { childList: true, subtree: true });
  }
  const main = document.getElementById('MainContent');
  if (main) {
    // Only the currency label on product-page recommendation prices. Preserve
    // numeric values, sale markup, API data, and native cart/tracking handlers.
    const unifyPriceLabels = root => {
      if (!document.body.classList.contains('template-product')) return;
      const prices = [...root.querySelectorAll('.ri-card-price')];
      if (root.matches?.('.ri-card-price')) prices.push(root);
      const visit = node => {
        for (const child of node.childNodes) {
          if (child.nodeType === 3) child.textContent = child.textContent.replace(/\bRON\b/g, 'lei');
          else if (child.nodeType === 1) visit(child);
        }
      };
      prices.forEach(visit);
    };
    const renameMaterials = root => {
      if (root.matches?.('.iu-curation-material-row')) root.setAttribute('aria-label', 'Material');
      root.querySelectorAll('.iu-curation-material-row').forEach(row => row.setAttribute('aria-label', 'Material'));
      unifyPriceLabels(root);
    };
    renameMaterials(main);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node instanceof Element) renameMaterials(node);
    }))).observe(main, { childList: true, subtree: true });
  }
  const upgradeFilters = root => {
    for (const heading of root.querySelectorAll('.sidebarBlock-heading.is-clicked, .sidebarBlock-heading:not(.is-clicked)')) {
      if (!heading.closest('collection-filters-form') || heading.closest('.refined-widgets') || heading.dataset.iuKeyboardReady) continue;
      heading.dataset.iuKeyboardReady = '1';
      heading.tabIndex = 0;
      heading.setAttribute('role', 'button');
      const sync = () => heading.setAttribute('aria-expanded', heading.classList.contains('is-clicked') ? 'true' : 'false');
      sync();
      heading.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); heading.click(); }
      });
      heading.addEventListener('click', () => requestAnimationFrame(sync));
    }
  };
  upgradeFilters(document);
  const sidebar = document.querySelector('#main-collection-filters');
  if (sidebar) new MutationObserver(() => upgradeFilters(sidebar)).observe(sidebar, { childList: true, subtree: true });
})();
